import { Controller, useFormContext } from 'react-hook-form'
import { Label } from '@/components/ui/label'
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from '@/components/ui/select'
import { ProductModel } from '@/types/model/Product'

interface VariantAttributesSelectorProps {
    index: number
    relevantAttributes: ProductModel.IAttribute[]
}

export const VariantAttributesSelector = ({
    index,
    relevantAttributes,
}: VariantAttributesSelectorProps) => {
    const { control } = useFormContext<ProductModel.ProductFormData>()

    if (!relevantAttributes?.length) return null

    return (
        <div className="grid grid-cols-1 gap-4 border-y border-border-subtle py-4 sm:grid-cols-2 lg:grid-cols-3">
            {relevantAttributes.map((attr) => (
                <div key={attr._id} className="space-y-1.5">
                    <Label>{attr.name}</Label>
                    <Controller
                        control={control}
                        name={`variations.${index}.attribute_value_ids`}
                        render={({ field }) => {
                            const currentValue = (field.value || []).find((id: string) =>
                                attr.values.some((v) => v._id === id)
                            ) || ''

                            return (
                                <Select
                                    value={currentValue}
                                    onValueChange={(newValue) => {
                                        const otherValues = (field.value || []).filter((id: string) =>
                                            !attr.values.some((v) => v._id === id)
                                        )
                                        field.onChange([...otherValues, newValue])
                                    }}
                                >
                                    <SelectTrigger>
                                        <SelectValue placeholder={`Select ${attr.name}`} />
                                    </SelectTrigger>
                                    <SelectContent>
                                        {attr.values.map((val) => (
                                            <SelectItem key={val._id} value={val._id}>
                                                <div className="flex items-center gap-2">
                                                    {val.color_code && (
                                                        <div
                                                            className="size-4 rounded-full border border-border"
                                                            style={{ backgroundColor: val.color_code }}
                                                        />
                                                    )}
                                                    <span>{val.name}</span>
                                                </div>
                                            </SelectItem>
                                        ))}
                                    </SelectContent>
                                </Select>
                            )
                        }}
                    />
                </div>
            ))}
        </div>
    )
}
